import { render, staticRenderFns } from "./DynamicTopMatter.vue?vue&type=template&id=6df822e6&scoped=true"
import script from "./DynamicTopMatter.vue?vue&type=script&lang=ts"
export * from "./DynamicTopMatter.vue?vue&type=script&lang=ts"
import style0 from "./DynamicTopMatter.vue?vue&type=style&index=0&id=6df822e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df822e6",
  null
  
)

export default component.exports